import { createEntityAdapter, EntityState } from "@ngrx/entity";
import { ICart, ICartItem } from "projects/shared/models/interfaces/cart.model";

export interface CartState extends EntityState<ICartItem> {
  initialized: boolean,
  loading: boolean,
  cart: ICart,
  getCartSuccess: string;
  getCartFailure: string;
  updateCartSuccess: string;
  updateCartFailure: string;
}

export const CartAdapter = createEntityAdapter<ICartItem>({
  selectId: (item: ICartItem) => item.product,
})

export const InitialCartState: CartState = CartAdapter.getInitialState({
  initialized: false,
  loading: false,
  cart: {} as ICart,
  getCartSuccess: '',
  getCartFailure: '',
  updateCartSuccess: '',
  updateCartFailure: ''
})